import getTitle from 'helpers/getTitle'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import _ from "lodash";
import {ItemInformation} from 'components/common/ItemInformation'

export const renderExaminationQuestionSet = ({translate: t, renderContextMenu = NullAsDefault, handleAction = NullAsDefault }) => (item, index) => {

    return (
        <div key={index} className="p-4 custom-item-render transition-all duration-300 relative list-item">
            <div
                onClick={() =>{handleAction('questions', item)}}
                className="font-bold text-lg text-color-000 hover:text-primary cursor-pointer">
                {getTitle(item)}
            </div>
            <div className="mb-2 pb-2 border-b border-color-50 text-color-300 tracking-wider">
                {item?.description}
            </div>
            <ItemInformation
                showIcon={true}
                label="total of questions"
                value={`${_.get(item, 'total_questions')} ${t('ask')}`}
                className="italic"
            />
            <div className="absolute right-8 top-8 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}

